export default __webpack_public_path__ + "static/media/new.e4dce58b.png";